module.exports = __webpack_public_path__ + "img/wx.9e8c1028.png";